import * as React from 'react';
import * as ReactGA from 'react-ga';
import { useHistory } from 'react-router';
import {
    Paper,
    List,
    Divider,
    Drawer,
    Button,
    ListItem,
    ListItemIcon,
    ListItemText,
    Snackbar,
    Checkbox,
    TextField,
    Box,
    Tooltip,
} from '@material-ui/core';
import RewindLeftIcon from '../../../../Assets/rewind_left.png';
import RewindRightIcon from '../../../../Assets/rewind_right.png';
import {
    Clear,
    Save,
    Undo,
    FormatColorText,
    Texture,
} from '@material-ui/icons';
import { useState, useEffect, useReducer, useCallback } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Alert } from '@material-ui/lab';
import { flow } from 'fp-ts/lib/function';
import { IProps } from './types';
import {
    setModeAction,
    changeText,
    changeFontSize,
    changeTextColor,
    changeTextBackgroundColor,
    saveTextBox,
    callChromakeyAction,
    withTelestrationState,
    changeTelestrationColor,
} from '../../State';
import { IAction, EditMode } from '../../Types';
import { reducer, initialState } from './reducer';
import {
    chromakeyTools,
    drawTools,
    editTools,
    recordTools,
} from '../../../../Assets/videoVideoLibrary';
import { withLocalState } from '../../../../App/LocalState';
import { SaveTelestrationModal } from '../SaveTelestrationModal';
import { ColorPicker } from '../ColorPicker';
import { StopRecording } from '../StopRecording';
import { startRecorder } from '../../Utils/Recording';

import backIconNew from '../../../../Assets/back-icon-new.png';
import KfLogo from '../../../../Assets/kflogo_cut_new.png';
import KeyframeLogoIcon from '../../../../Assets/keyframe_logo.png';
import ChromaKeyIcon from '../../Assets/Chromakey.png';
import PlayerCutOutIcon from '../../../../Assets/copy.png';
import ArrowIcon from '../../../../Assets/diagarrowdown.png';
import FreehandArrowIcon from '../../../../Assets/arrowfree.png';
import CircleIcon from '../../../../Assets/circle.png';
import ClearIcon from '../../../../Assets/clear3.png';
import UndoIcon from '../../../../Assets/undo.png';
import RedoIcon from '../../../../Assets/redo.png';
import RecordIcon from '../../../../Assets/recordb.png';
import MaskIcon from '../../../../Assets/mask3.png';
import MaskIconNew from '../../../../Assets/masked_transitions.png';
import PolygonIcon from '../../../../Assets/area.png';
import LightShaftIcon from '../../../../Assets/spotlight.png';
import LinkedCursorIcon from '../../../../Assets/share.png';
import StraightArrowIcon from '../../../../Assets/diagarrow.png';
import UndoNewIcon from '../../../../Assets/undo-new.png';
import RedoNewIcon from '../../../../Assets/redo-new.png';
import ClearNewIcon from '../../../../Assets/delete-new.png';
import InfoNewIcon from '../../../../Assets/info-new.png';
import {
    telestrationCircleClicked,
    telestrationClickedUndo,
    telestrationHaloClicked,
    telestrationLinkClicked,
    telestrationMaskClicked,
    telestrationPolygonClicked,
    telestrationRecordingCountdown,
    telestrationRecordingStarted,
    telestrationRecordingFinished,
    telestrationStraightArrowClicked,
    telestrationSegmentArrowClicked,
    telestrationClearClicked,
    telestrationSaveMask,
    telestrationUndoMask,
} from 'src/App/UserEvents';
import { sendUserEvent } from 'src/App/UserEvents/UserEventManager';
import { styles } from './TelestrationControlsStyles';
import { ChromakeyActionButton } from './ChromakeyActionButton';
import { ToolButtonIcon } from './ToolButtonIcon';
import { ChromakeyDialog } from '../ChromakeyDialog';
import { RecordDialog } from '../RecordDialog';
import {
    initialToolSizes,
    initialToolPerspectives,
    toolsDrawerInitialState,
    initialToolTypes,
} from './toolsSettings';
import { ToolAdjustmentDrawer } from './ToolAdjustmentDrawer';

const iconsByMode = {
    chromakey: MaskIcon,
    record: RecordIcon,
    lightshaft: LightShaftIcon,
    polygon_t: PolygonIcon,
    arrow: ArrowIcon,
    straightarrow: StraightArrowIcon,
    freearrow: FreehandArrowIcon,
    circle: CircleIcon,
    linkedcursor: LinkedCursorIcon,
    playercutout: PlayerCutOutIcon,
    default: ClearIcon,
    undo: UndoIcon,
    redo: RedoIcon,
};
const headerIconsByMode = {
    chromakey: MaskIconNew,
    undo: UndoNewIcon,
    redo: RedoNewIcon,
    default: ClearNewIcon,
};

const toolTypeArray = ['arrow', 'freearrow', 'playercutout', 'straightarrow'];
const chromakeyActionButtons = [
    { name: 'undo', icon: <Undo /> },
    { name: 'clear', icon: <Clear /> },
    { name: 'save', icon: <Save /> },
];

const getIcons = (classes: any) => {
    const tools = [...chromakeyTools, ...drawTools, ...editTools];
    return tools.map((tool) => ({
        ...tool,
        icon: (
            <img
                className={classes.iconTool}
                src={iconsByMode[tool.mode]}
                alt={tool.mode}
            />
        ),
    }));
};
const getHeaderIcons = (classes: any) => {
    const tools = [...chromakeyTools, ...drawTools, ...editTools];
    return tools.map((tool) => ({
        ...tool,
        icon: (
            <img
                className={classes.iconTool}
                src={headerIconsByMode[tool.mode]}
                alt={tool.mode}
            />
        ),
    }));
};

const getRecordIcons = (classes: any) => {
    const tools = [...recordTools];
    return tools.map((tool) => ({
        ...tool,
        icon: (
            <img
                className={classes.iconTool}
                src={iconsByMode[tool.mode]}
                alt={tool.mode}
            />
        ),
    }));
};

const hintMessages = {};

const defaulTextBoxState = {
    text: '',
    fontSize: 18,
    textColor: false,
    backgroundColor: false,
};

let chromakeyUsed = false;

const telestrationControls = ({
    videoID,
    videoTitle,
    classes,
    telestrationStateMgr,
    localStateMgr,
    license,
}: IProps) => {
    const [showChromeKeyDialog, setShowChromeKeyDialog] = useState(true);
    const [showRecordDialog, setShowRecordDialog] = useState(true);
    const [textBoxState, setTextBoxState] = useState(defaulTextBoxState);
    // close at is being used to track time diff to show two popups
    const [closeAt, setClosedAt] = useState(0);
    const [toolPerspectives, setToolPerspectives] = useState(
        initialToolPerspectives
    );
    const [toolSizes, setToolSizes] = useState(initialToolSizes);
    const [toolTypes, setToolTypes] = useState(initialToolTypes);
    const [toolsDrawerState, setToolsDrawerState] = useState(
        toolsDrawerInitialState
    );
    const [hints, setHints]: any = useState({});

    const [uploadState, dispatchUploadStateAction] = useReducer(
        reducer,
        initialState
    );

    const history = useHistory();

    const icons = getIcons(classes);
    const headerIcons = getHeaderIcons(classes);
    const recordIcons = getRecordIcons(classes);
    const { state, dispatchAction } = telestrationStateMgr;
    const { editMode } = state;
    const LOCAL_STORAGE_TOOLS_PERSPECTIVES_KEY = 'TOOLS_PERSPECTIVES_KEY';
    const LOCAL_STORAGE_TOOLS_SIZES_KEY = 'TOOLS_SIZES_KEY';
    const LOCAL_TOOLS_TYPE_KEY = 'TOOLS_TYPE_KEY';
    const LOCAL_SHOW_EXPERT_DIALOG = 'doNotShow_ShowExpertDialog';
    const DONT_SHOW_PROMPT_FOR_CHROME_KEY =
        localStorage.getItem('doNotShow_chromakey') === 'true';
    const DONT_SHOW_PROMPT_FOR_RECORD =
        localStorage.getItem('doNotShow_record') === 'true';

    useEffect(() => {
        if (!chromakeyUsed && state.recording.recordingActive) {
            setHints((prev: any) => ({
                ...prev,
                record: true,
            }));
        }
    }, [state.recording.recordingActive]);

    useEffect(() => {
        chromakeyUsed = false;
        const savedToolsPerspectives = JSON.parse(
            localStorage.getItem(LOCAL_STORAGE_TOOLS_PERSPECTIVES_KEY) ||
                '{"empty":true}'
        );
        const savedToolsSizes = JSON.parse(
            localStorage.getItem(LOCAL_STORAGE_TOOLS_SIZES_KEY) ||
                '{"empty":true}'
        );

        const savedToolsType = JSON.parse(
            localStorage.getItem(LOCAL_TOOLS_TYPE_KEY) || '{"empty":true}'
        );

        if (!savedToolsPerspectives.empty) {
            setToolPerspectives(savedToolsPerspectives);
        }
        if (!savedToolsSizes.empty) {
            setToolSizes(savedToolsSizes);
        }
        if (!savedToolsType.empty) {
            setToolTypes(savedToolsType);
        }
    }, []);

    useEffect(() => {
        window.addEventListener('beforeunload', keepOnPage);
        return () => window.removeEventListener('beforeunload', keepOnPage);
    }, [uploadState.uploadQueue]);

    useEffect(() => {
        if (
            toolsDrawerState[editMode] &&
            !toolsDrawerState[editMode].wasClosed &&
            !toolsDrawerState[editMode].currentlyOpen
        ) {
            setToolsDrawerState((prev: any) => ({
                ...prev,
                [editMode]: {
                    wasClosed: false,
                    currentlyOpen: true,
                },
            }));
        }
    }, [editMode]);

    useEffect(() => {
        if (DONT_SHOW_PROMPT_FOR_CHROME_KEY) {
            const currentTimeInEpoc = new Date().getTime();
            setClosedAt(currentTimeInEpoc);
        }
    }, []);

    const onColorPick = ({ rgb }: any) => {
        const { r, g, b, a } = rgb;
        let action = null;
        if (editMode === 'textbox') {
            action = textBoxState.textColor
                ? changeTextColor
                : changeTextBackgroundColor;
        } else {
            action = changeTelestrationColor;
        }

        dispatchAction(action(`rgba(${r}, ${g}, ${b}, ${a})`));
    };

    const needColorPicker = () => {
        switch (editMode) {
            case 'polygon_t':
            case 'arrow':
            case 'straightarrow':
            case 'freearrow':
            case 'circle':
            case 'linkedcursor':
            case 'playercutout':
                return true;
            case 'textbox':
                return textBoxState.textColor || textBoxState.backgroundColor;
            default:
                return false;
        }
    };

    const openUploadModal = () =>
        dispatchUploadStateAction({
            type: 'TOGGLE_SAVE_TELESTRATION_MODAL',
            payload: true,
        });

    const closeUploadModal = () =>
        dispatchUploadStateAction({
            type: 'TOGGLE_SAVE_TELESTRATION_MODAL',
            payload: false,
        });

    const onSaveTelestration = (id: string, title: string) =>
        localStateMgr.dispatch({
            type: 'ON_UPLOAD_START',
            video: {
                id,
                title,
                progress: 0,
            },
        });

    const onUploadProgress = (id: string, percentage: number) =>
        localStateMgr.dispatch({
            type: 'ON_UPLOAD_PROGRESS',
            videoID: id,
            percentage,
        });

    const onStartConversion = (id: string) =>
        localStateMgr.dispatch({
            type: 'ON_START_CONVERSION',
            videoID: id,
        });

    const onStartDownload = (id: string) =>
        localStateMgr.dispatch({
            type: 'ON_START_DOWNLOADING',
            videoID: id,
        });

    const onUploadSuccess = (id: string) =>
        localStateMgr.dispatch({
            type: 'ON_UPLOAD_SUCCESS',
            videoID: id,
        });

    const onStopRecording = useCallback(() => {
        changeMode('stop_recording', false)();
        openUploadModal();
    }, []);

    const doNotShowHint = (flag: boolean, h: string) => {
        flag
            ? localStorage.setItem(`doNotShow_${h}`, `${flag}`)
            : localStorage.removeItem(`doNotShow_${h}`);
    };

    const hintSnackbars = Object.keys(hints)
        .filter((h) => hints[h])
        .map((h, i) => {
            return hints[h] &&
                !localStorage.getItem(`doNotShow_${h}`) &&
                hintMessages[h] ? (
                <Snackbar
                    key={i}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    autoHideDuration={2000}
                    open={true}
                    style={{ top: 80 * i + 10 || 10 }}
                >
                    <Alert
                        variant='filled'
                        severity='info'
                        style={{ background: 'rgb(236, 77, 69)' }}
                        onClose={() =>
                            setHints((prev: any) => ({
                                ...prev,
                                [h]: false,
                            }))
                        }
                        icon={
                            h === 'record' ? (
                                <img
                                    src={ChromaKeyIcon}
                                    onClick={() =>
                                        changeMode('chromakey', true)()
                                    }
                                    style={{
                                        width: '22px',
                                        height: '22px',
                                        cursor: 'pointer',
                                    }}
                                    alt='chromakey'
                                />
                            ) : undefined
                        }
                    >
                        <div
                            style={{ display: 'flex', flexDirection: 'column' }}
                        >
                            {hintMessages[h]}
                            <div
                                style={{
                                    margin: '0px 0px -9px -42px',
                                    fontSize: '13px',
                                }}
                            >
                                <Checkbox
                                    size='small'
                                    onChange={(e) =>
                                        doNotShowHint(e.target.checked, h)
                                    }
                                    style={{ color: '#fff' }}
                                />
                                Do not show me this message again
                            </div>
                        </div>
                    </Alert>
                </Snackbar>
            ) : null;
        });

    const changeMode = (newEditMode: EditMode, needHint?: boolean) => () => {
        ReactGA.event({ category: 'Telestration Mode', action: newEditMode });
        const action = setModeAction(
            newEditMode,
            needHint ? setHints : null
        ) as IAction;
        handleSendUserClickEvents(newEditMode);

        if (newEditMode === 'chromakey' || newEditMode === 'default') {
            setToolsDrawerState((prev: any) => ({
                ...prev,
                [editMode]: {
                    wasClosed: true,
                    currentlyOpen: false,
                },
            }));
        } else if (newEditMode === editMode) {
            setToolsDrawerState((prev: any) => ({
                ...prev,
                [editMode]: {
                    wasClosed: false,
                    currentlyOpen: true,
                },
            }));
        } else {
            setToolsDrawerState((prev: any) => ({
                ...prev,
                [editMode]: {
                    wasClosed: true,
                    currentlyOpen: false,
                },
                [newEditMode]: {
                    wasClosed: false,
                    currentlyOpen: true,
                },
            }));
        }

        return dispatchAction(action);
    };

    function handleSendUserClickEvents(newEditMode: EditMode): void {
        const url = window.location.href;
        switch (newEditMode) {
            case 'chromakey': {
                // mask tool clicked
                return sendUserEvent(telestrationMaskClicked, url, videoID);
            }
            case 'polygon_t': {
                return sendUserEvent(telestrationPolygonClicked, url, videoID);
            }
            case 'lightshaft': {
                // halo tool
                return sendUserEvent(telestrationHaloClicked, url, videoID);
            }
            case 'straightarrow': {
                return sendUserEvent(
                    telestrationStraightArrowClicked,
                    url,
                    videoID
                );
            }
            case 'arrow': {
                return sendUserEvent(
                    telestrationSegmentArrowClicked,
                    url,
                    videoID
                );
            }
            case 'circle': {
                return sendUserEvent(telestrationCircleClicked, url, videoID);
            }
            case 'linkedcursor': {
                return sendUserEvent(telestrationLinkClicked, url, videoID);
            }
            case 'default': {
                return sendUserEvent(telestrationClearClicked, url, videoID);
            }
            case 'undo': {
                return sendUserEvent(telestrationClickedUndo, url, videoID);
            }
            case 'record_countdown': {
                setTimeout(() => {
                    const recordingStartResult = startRecorder(
                        state.recording.recordingCanvasRef,
                        setHints
                    );
                    changeMode('record', false)();
                }, 3000);
            }
            case 'record': {
                if (state.recording.recordingActive) {
                    return sendUserEvent(
                        telestrationRecordingFinished,
                        url,
                        videoID
                    );
                } else {
                    return sendUserEvent(
                        telestrationRecordingStarted,
                        url,
                        videoID
                    );
                }
            }
            default: {
                return;
            }
        }
    }

    const keepOnPage = (event: any) => {
        const message = 'Warning! Video in progress. Leave anyway?';
        if (Object.keys(uploadState.uploadQueue).length) {
            event.returnValue = message;
            return message;
        }
        return true;
    };

    const updateChromKeyDialogStatus = (status: boolean) => {
        if (status) {
            setShowChromeKeyDialog(true);
        } else {
            const timeInEpoc = new Date().getTime();
            setClosedAt(timeInEpoc);
            setShowChromeKeyDialog(false);
        }
    };

    const updateRecordDialogStatus = (status: boolean) => {
        if (status) {
            setShowRecordDialog(true);
        } else {
            const timeInEpoc = new Date().getTime();
            setClosedAt(timeInEpoc);
            setShowRecordDialog(false);
            changeMode('default', false)();
        }
    };

    const excludedIndices = new Set([0, 9, 10, 11]);

    const labels = {
        0: 'Pitch Mask',
        10: 'Undo',
        11: 'Redo',
        9: 'Clear',
    };
    return (
        <>
            <Paper className={classes.root}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%',
                        padding: '0 20px',
                        alignItems: 'center',
                        borderBottom: 'solid 1px #3F3F50',
                    }}
                >
                    <div
                        style={{
                            height: '71px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            // marginTop: '27px',
                            // justifyContent: 'space-between',
                        }}
                        className={`${classes.cardBody} ${classes.cardBodyPadding}`}
                    >
                        <div
                            className={classes.backIconWrapper}
                            onClick={() => history.push('/video-library')}
                        >
                            <img
                                src={backIconNew}
                                width='5'
                                height='7'
                                style={{
                                    cursor: 'pointer',
                                }}
                            />
                        </div>
                        <span
                            style={{
                                fontSize: '20px',
                                color: '#ffffff',
                                fontWeight: 500,
                            }}
                        >
                            {videoTitle.split('.')[0]}
                        </span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <List className={classes.headerToolsListWrapper}>
                            {[0, 10, 11, 9].map((i) => (
                                <ToolButtonIcon
                                    key={i}
                                    iconParameters={headerIcons[i]}
                                    openUploadModal={openUploadModal}
                                    changeMode={changeMode}
                                    setHints={setHints}
                                    headerMenu={true}
                                    hideTooltip={true}
                                >
                                    {labels[i]}
                                </ToolButtonIcon>
                            ))}
                        </List>
                        <span
                            style={{
                                width: 1,
                                height: 24,
                                backgroundColor: 'rgba(250, 250, 250, 0.2)',
                                margin: '0 16px',
                            }}
                        >
                            &nbsp;
                        </span>
                        <div className={classes.licenceAndInfoDetails}>
                            {license && (
                                <Box
                                    style={{
                                        textTransform: 'capitalize',
                                    }}
                                >
                                    <a
                                        onClick={() =>
                                            window.open(
                                                process.env
                                                    .REACT_APP_STRIPE_PORTAL +
                                                    '',
                                                '_blank'
                                            )
                                        }
                                        href='#'
                                        style={{
                                            textDecoration: 'none',
                                            color: '#121217',
                                        }}
                                    >
                                        <Box
                                            style={{
                                                height: '40px',
                                                width: 'fit-content',
                                                display: 'flex',
                                                alignItems: 'center',
                                                marginTop: 0,
                                                backgroundColor:
                                                    'rgba(250,250,250,0.1)',
                                                borderRadius: '8px',
                                                justifyContent: 'flex-end',
                                            }}
                                        >
                                            <Box
                                                style={{
                                                    float: 'right',
                                                    textAlign: 'center',
                                                    alignItems: 'center',
                                                    padding: '0 16px',
                                                    fontWeight: 400,
                                                    fontSize: 14,
                                                    color: '#ffffff',
                                                }}
                                            >
                                                Account
                                            </Box>
                                        </Box>
                                    </a>
                                </Box>
                            )}

                            {!license && (
                                <Box
                                    style={{
                                        textTransform: 'capitalize',
                                    }}
                                >
                                    <a
                                        href='/payments/make-payment'
                                        style={{
                                            color: '#121217',
                                            textDecoration: 'none',
                                        }}
                                    >
                                        <Box
                                            style={{
                                                height: '40px',
                                                width: 'fit-content',
                                                display: 'flex',
                                                backgroundColor:
                                                    'rgba(250,250,250,0.1)',
                                                borderRadius: '8px',
                                                justifyContent: 'flex-end',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <Box
                                                style={{
                                                    float: 'right',
                                                    textAlign: 'center',
                                                    alignItems: 'center',
                                                    padding: '0 16px',
                                                    fontWeight: 400,
                                                    fontSize: 14,
                                                    color: '#ffffff',
                                                }}
                                            >
                                                Buy a License
                                            </Box>
                                        </Box>
                                    </a>
                                </Box>
                            )}
                        </div>
                    </div>
                </div>
            </Paper>
            <div>
                <StopRecording
                    open={state.recording.recordingActive}
                    onStopRecording={onStopRecording}
                />
                {hintSnackbars}
                <SaveTelestrationModal
                    telestratedvideoID={videoID}
                    open={uploadState.saveTelestrationModal.open}
                    //open={true}
                    closeModal={closeUploadModal}
                    onSaveTelestration={onSaveTelestration}
                    onProgress={onUploadProgress}
                    onStartConversion={onStartConversion}
                    onStartDownload={onStartDownload}
                    onSuccess={onUploadSuccess}
                />
                <Drawer
                    className={classes.drawer}
                    open={true}
                    variant='persistent'
                    classes={{
                        paper: `${classes.drawerPaper} ${
                            localStateMgr.state.leftSideMenuOpen || 'closed'
                        }`,
                    }}
                    style={{
                        userSelect: 'none',
                        maxWidth: '6px',
                        width: '66px',
                    }}
                >
                    <div className={classes.toolbar}>
                        <div className={classes.toolbarTitle}>
                            <img
                                onClick={() => history.push('/video-library')}
                                src={KfLogo}
                            />
                        </div>
                    </div>
                    <div>
                        <List style={{ marginLeft: 8 }}>
                            {icons
                                .filter(
                                    (_, index) => !excludedIndices.has(index)
                                )
                                .map((icon, index) => (
                                    <ToolButtonIcon
                                        key={index}
                                        iconParameters={icon}
                                        openUploadModal={openUploadModal}
                                        changeMode={changeMode}
                                        setHints={setHints}
                                    />
                                ))}
                        </List>
                    </div>
                </Drawer>
                <Drawer
                    className={classes.drawer}
                    open={editMode === 'textbox'}
                    variant='persistent'
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexDirection: 'column',
                            padding: '0px 15px',
                        }}
                    >
                        <TextField
                            label='Text'
                            onFocus={(e) => {
                                /* tslint:disable-next-line */
                                window['STOP_KEY_LISTENERS'] = true;
                            }}
                            onBlur={(e) => {
                                /* tslint:disable-next-line */
                                window['STOP_KEY_LISTENERS'] = false;
                            }}
                            onChange={(e) => {
                                dispatchAction(changeText(e.target.value));
                                setTextBoxState({
                                    ...textBoxState,
                                    text: e.target.value,
                                });
                            }}
                            value={textBoxState.text}
                        />
                        <TextField
                            label='Font Size'
                            type='number'
                            style={{ margin: '5px 0px' }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            value={textBoxState.fontSize}
                            onChange={(e) => {
                                dispatchAction(changeFontSize(+e.target.value));
                                setTextBoxState({
                                    ...textBoxState,
                                    fontSize: +e.target.value,
                                });
                            }}
                        />
                    </div>
                    <List>
                        <ListItem
                            onClick={() =>
                                setTextBoxState({
                                    ...textBoxState,
                                    backgroundColor: false,
                                    textColor: true,
                                })
                            }
                            className={classes.actionButton}
                        >
                            <ListItemIcon style={{ minWidth: '40px' }}>
                                <FormatColorText />
                            </ListItemIcon>
                            <ListItemText disableTypography>
                                Change Text Color
                            </ListItemText>
                        </ListItem>
                        <ListItem
                            onClick={() =>
                                setTextBoxState({
                                    ...textBoxState,
                                    textColor: false,
                                    backgroundColor: true,
                                })
                            }
                            className={classes.actionButton}
                        >
                            <ListItemIcon style={{ minWidth: '40px' }}>
                                <Texture />
                            </ListItemIcon>
                            <ListItemText disableTypography>
                                Change Background Color
                            </ListItemText>
                        </ListItem>
                        <ListItem
                            onClick={() => {
                                dispatchAction(saveTextBox());
                                setTextBoxState(defaulTextBoxState);
                            }}
                            className={classes.actionButton}
                        >
                            <ListItemIcon style={{ minWidth: '40px' }}>
                                <Save />
                            </ListItemIcon>
                            <ListItemText disableTypography>Save</ListItemText>
                        </ListItem>
                    </List>
                </Drawer>
                <ToolAdjustmentDrawer
                    toolsDrawerState={toolsDrawerState}
                    toolSizes={toolSizes}
                    setToolSizes={setToolSizes}
                    toolTypes={toolTypes}
                    setToolTypes={setToolTypes}
                    toolPerspectives={toolPerspectives}
                    setToolPerspectives={setToolPerspectives}
                    setToolsDrawerState={setToolsDrawerState}
                    onColorPick={onColorPick}
                    needColorPicker={needColorPicker()}
                />
                {!localStateMgr.state.isTouchDevice && (
                    <ChromakeyDialog
                        open={showChromeKeyDialog}
                        editMode={editMode}
                        updateChromKeyDialogStatus={updateChromKeyDialogStatus}
                    />
                )}
                {!localStateMgr.state.isTouchDevice && (
                    <RecordDialog
                        open={showRecordDialog}
                        editMode={editMode}
                        updateRecordDialogStatus={updateRecordDialogStatus}
                    />
                )}
            </div>
            {(editMode === 'chromakey' ||
                editMode === 'chromakey_first_mount') && (
                <Box
                    style={{
                        zIndex: 1111,
                        position: 'absolute',
                        height: 54,
                        left: 64,
                        padding: '0 16px',
                        top: 70,
                        bottom: 'auto',
                        width: 'calc(100% - 64px)',
                        backgroundColor: '#3F3F50',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <div
                        style={{
                            width: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                        }}
                    >
                        <img
                            style={{}}
                            src={MaskIconNew}
                            width={20}
                            height={20}
                        />
                        <div
                            style={{
                                fontSize: 14,
                                fontWeight: 400,
                                color: '#ffffff',
                            }}
                        >
                            {' '}
                            Click in the green areas on the pitch..
                        </div>
                    </div>
                    <div className={classes.actionButtonsWrapper}>
                        <Button
                            key='undo'
                            className={'action-button'}
                            style={{}}
                            onClick={() => {
                                sendUserEvent(
                                    telestrationSaveMask,
                                    window.location.href,
                                    videoID
                                );

                                const actionToDispatch = callChromakeyAction(
                                    'undo'
                                );
                                dispatchAction(actionToDispatch);
                            }}
                        >
                            Undo
                        </Button>
                        <Button
                            key='cancel'
                            className={'action-button'}
                            onClick={() => {
                                sendUserEvent(
                                    telestrationSaveMask,
                                    window.location.href,
                                    videoID
                                );

                                const actionToDispatch = callChromakeyAction(
                                    'clear'
                                );
                                dispatchAction(actionToDispatch);
                            }}
                        >
                            Reset
                        </Button>
                        <Button
                            key='complete'
                            className={'action-button action-filled-button'}
                            onClick={() => {
                                sendUserEvent(
                                    telestrationSaveMask,
                                    window.location.href,
                                    videoID
                                );

                                const actionToDispatch = callChromakeyAction(
                                    'save'
                                );
                                dispatchAction(actionToDispatch);

                                dispatchAction(
                                    setModeAction('record_first_mount')
                                );
                            }}
                        >
                            Complete
                        </Button>
                    </div>
                </Box>
            )}
            {editMode === 'record_countdown' && (
                <div
                    style={{
                        zIndex: 6000,
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(206, 206, 206, 0.9)',
                    }}
                >
                    <div
                        style={{
                            opacity: 0,
                            animation: 'show 0.5s 0s , hide 0.5s 0.5s ',
                            fontSize: '100px',
                            width: 'fit-content',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }}
                    >
                        3
                    </div>
                    <div
                        style={{
                            opacity: 0,
                            animation: 'show 0.5s 1s , hide 0.5s 1.5s ',
                            fontSize: '100px',
                            width: 'fit-content',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }}
                    >
                        2
                    </div>
                    <div
                        style={{
                            opacity: 0,
                            animation: 'show 0.5s 2s , hide 0.5s 2.5s',
                            fontSize: '100px',
                            width: 'fit-content',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }}
                    >
                        1
                    </div>
                </div>
            )}
            {!state.recording.recordingActive && (
                <div className={classes.recordinBtnWrapper}>
                    <div
                        onClick={() => {
                            changeMode('record_countdown', false)();
                        }}
                        style={{
                            cursor: 'pointer',
                            width: '100%',
                            backgroundColor: '#DB2C29',
                            borderRadius: 8,
                            height: 40,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 0,
                        }}
                    >
                        {recordIcons.map((icon, index) => (
                            <ToolButtonIcon
                                key={index}
                                iconParameters={icon}
                                openUploadModal={openUploadModal}
                                changeMode={changeMode}
                                setHints={setHints}
                            />
                        ))}
                        <div
                            style={{
                                fontSize: 14,
                            }}
                        >
                            Start Recording
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export const TelestrationControls = flow(
    withTelestrationState,
    withLocalState,
    withStyles(styles)
)(telestrationControls);
